import { ProgressBar, Spinner } from 'avo-ui'

export const Import = ({ percentage }) => {
    return (
        <div className={'w-5/6 flex flex-col space-y-4 border rounded-lg'}>
            <div className={'flex flex-col space-y-6 p-6 border-b'}>
                <p className={'text-lg text-blue-90'}>Importing</p>
                <div className={'flex items-center space-x-4'}>
                    <p className={'text-neutral-80'}>Your product are now being imported...</p>
                    <Spinner className={'w-6 h-6 border-blue-50'} />
                </div>
            </div>
            <div className={'w-full flex flex-col items-center space-y-5 p-8'}>
                <ProgressBar percentage={percentage} />
                <p className={'font-bold text-lg text-blue-90'}>Progress in {percentage}%</p>
            </div>
        </div>
    )
}
